export default __webpack_public_path__ + "static/media/living-cz-logo-dark-bg.3e3c6ee7.svg";